module.exports = __webpack_public_path__ + "img/img_6.5bf00c92.png";